module.exports = __webpack_public_path__ + "static/media/three_dot_circle.2aeef847.svg";